import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { NetflixLogoRoundIcon } from './NetflixLetterLogoRound';

export const NetflixIconModeDesktop = styled(NetflixLogoRoundIcon)``;
export const NetflixIconModeMobile = styled(Icon).attrs({ size: 'md' })``;

export const DualMode = styled.span.attrs({ role: 'presentation' })`
    ${purpurMedia('sm')`
        ${NetflixIconModeDesktop} { display: none; }
        ${NetflixIconModeMobile} { display: flex; }
    `}
    ${purpurMedia('lg')`
        ${NetflixIconModeDesktop} { display: flex; }
        ${NetflixIconModeMobile} { display: none; }
    `}
`;
